import CourseContentLayoutInstructor from "./CourseContentLayoutInstructor";

function JuniorCourse(props) {
  return <CourseContentLayoutInstructor {...props} totalModules={3} />;
}

export default JuniorCourse;